import { useContext, useEffect, useState } from "react";
import { FunctionsContext } from "../FunctionsContext";
import { PapsContext } from "../PapsContext";
import { StartContext } from "../StartContext";
import { startTypes } from "global/cnr/reducers/StartReducer";
import { _showAppLogs, LogContext } from "../LogContext";
import { convertHelpers } from "global/common/convert";

export const useRegDemo = ({ isRegDemo, settingsDocName, showToken }) => {

  // dzY0TwvC4ilKPo21DZtf38:APA91bGCjgfSZGqrefdjEzO_ZUYdJALgrDW1dkUrqSxjeg7f4T58U5-HkVLBEA5Y6R-Tt9cPp-zsP5WHDV_pWT-rtECF92BWfMXGOmHSES1KRMjiEv2tME55Jmsbi1IV5I4KpOKv5kF2
  // Ye17GCNCwVYNCNCcJo4QMTvPuKgSEkQi

  // logContext
  const logContext = useContext(LogContext)
  const { log_handlers } = logContext ?? {}

  // functionsContext
  const functionsContext = useContext(FunctionsContext);
  const { functions_cls } = functionsContext ?? {}

  const papsContext = useContext(PapsContext);
  const { paps_state } = papsContext
  const { pathViews } = paps_state ?? {}

  const startContext = useContext(StartContext);
  const { start_handlers } = startContext ?? {}

  const [regData_state, setRegData_state] = useState({})

  useEffect(() => {

    const getData = async () => {
      try {
        const getRegData = async () => {
          start_handlers.handleAmmend_startDimmer(startTypes.fetchingReg, 'pageAreaContent', settingsDocName)
          const response_regData = await functions_cls.getRegData(pathViews.clients, pathViews.events, true, showToken)
          const { result } = response_regData ?? {}
          try {
            const regInfo = result?.result
            regInfo.eventKey = pathViews.events
            if (regInfo?.projectSettings) {
              regInfo.projectSettings.settingsDocName = pathViews.events
            }
            if (regInfo?.appDataDocuments) {
              _.forEach(regInfo.appDataDocuments, (v, vk) => {
                convertHelpers.createItemKeys(v)
              })
            }
            _showAppLogs.eventInfo && log_handlers.addLog(`✅ regInfo(${settingsDocName}) from functions`);
            setRegData_state({ regInfo })
          } catch (error) {
            console.log('err', error)
          }
        }
        getRegData()
      } catch (err) {
        console.error(`❌ Failed to fetch reg data`, err);
      }
    }

    isRegDemo && settingsDocName && getData();

  }, [pathViews]);

  return regData_state;
}; 